import {
  type BrandCreate,
  BrandProductCategory,
  BrandTypeOfBusiness,
  BrandVoice,
  ExcerptPlatform,
  type ExcerptSubPlatformType,
} from '../entity/api/brand';
import { type User } from '../entity/api/user';
import { getQueryClient } from '../sdk/request';
import { getBrandFromCache, getBrandsListFromCache } from '../services/storage/brands-queries';
import { tNamespace } from '../services/translation';
import { getSelectedOrganization } from './organization';

// let selectedBrand: string | null = null;

// eslint-disable-next-line @typescript-eslint/require-await
export async function setSelectedBrand(brandId: string) {
  const queryClient = getQueryClient();
  const brandIsValid = getBrandFromCache(queryClient, brandId);

  // If the brand is not valid, we don't set it as selected
  if (brandIsValid == null) {
    return;
  }

  // selectedBrand = brand;
  sessionStorage.setItem('selected_brand_id', brandId);
}

export function getSelectedBrand(currentUser?: User | null, preferredOrgId?: string) {
  // TODO: what about local storage ?!
  const org = getSelectedOrganization(currentUser, preferredOrgId);
  if (org == null) {
    return undefined;
  }

  const queryClient = getQueryClient();
  const brand = getBrandFromCache(queryClient, currentUser?.selectedBrandId ?? 'not_setup');

  if (brand != null && brand.organizationId === org._id) {
    return brand;
  }

  const brandsList = getBrandsListFromCache(queryClient) ?? [];
  const orgBrand = brandsList.find((b) => b?.organizationId === org._id);

  return orgBrand;
}

export function returnSelectedType(platform: ExcerptPlatform, subPlatform: ExcerptSubPlatformType) {
  if (platform === ExcerptPlatform.Other) {
    return `${subPlatform}`;
  }

  const t = tNamespace('app.brand-context.-tab-excerpt');
  return `${t(platform)} - ${t(subPlatform)}`;
}

export function voiceTable(voice: BrandVoice) {
  const table = {
    [BrandVoice.FirstPersonSingular]: 'I',
    [BrandVoice.FirstPersonPlural]: 'We',
    [BrandVoice.SecondPerson]: 'You',
    [BrandVoice.ThirdPerson]: 'They',
  };
  return table[voice];
}

/**
 * Creates a BrandCreate object with default values
 * Used when creating a new brand with minimal initial data
 *
 * @param organizationId - The organization ID the brand belongs to
 * @param name - The brand name
 * @param websiteUrl - The brand's website URL
 * @returns BrandCreate object with all default values set
 */
export function createBrandCreateData(
  organizationId: string,
  name: string,
  websiteUrl: string
): BrandCreate {
  return {
    name: name,
    productType: '',
    companyWebsite: websiteUrl ?? '',
    organizationId: organizationId,
    isDefault: true,
    companyName: '',
    productCategory: BrandProductCategory.NA,
    typeOfBusiness: BrandTypeOfBusiness.NA,
    activity: '',
    extra: '',
    country: '',
    language: '',
    persona: [],
    excerpt: [],
    contentVoice: BrandVoice.FirstPersonPlural,
    contentVoiceTone: [],
    contentInclusiveLanguage: false,
    contentTalkAboutBrand: false,
    contentHasEmoji: false,
    productVoice: BrandVoice.FirstPersonPlural,
    productVoiceTone: [],
    productInclusiveLanguage: false,
    productTalkAboutBrand: false,
    collectionVoice: BrandVoice.FirstPersonPlural,
    collectionVoiceTone: [],
    collectionInclusiveLanguage: false,
    collectionTalkAboutBrand: false,
    blacklist: [],
  };
}
